import type { FC } from 'react';
import { Box } from '@interstate/components/Box';
import { Typography } from '@interstate/components/Typography';
import type { InfoCardRow, InfoCardField } from '../../types/AuditLog';
import { DealInformationColumn } from '../../types/AuditLog';
import { transformation } from '../Transformation';

const DealInformation: FC<{ data: Record<string, any> }> = ({ data }) => {
    return (
        <Box sx={{ display: 'flex' }}>
            {DealInformationColumn.map((item: InfoCardRow, index: number) => (
                <Box key={index} sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                    {item.fields.map((field: InfoCardField, fieldIndex: number) => (
                        <Box key={fieldIndex} sx={{ display: 'flex', flexDirection: 'row' }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'right',
                                    flexShrink: 0,
                                    width: field.labelWidth
                                }}
                            >
                                <Typography variant="body-xs" sx={{ color: '#6D6D6D' }}>
                                    {field.label}:
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'left', flex: 1, minWidth: '72px' }}>
                                <Typography variant="body-sm" sx={{ pl: 0.5, textTransform: 'capitalize' }}>
                                    {transformation.renderFieldValue(field, data[field.key])}
                                </Typography>
                            </Box>
                        </Box>
                    ))}
                </Box>
            ))}
        </Box>
    );
};

export default DealInformation;
